import { render, staticRenderFns } from "./LkVotes.vue?vue&type=template&id=74f4449f&scoped=true&"
import script from "./LkVotes.vue?vue&type=script&lang=js&"
export * from "./LkVotes.vue?vue&type=script&lang=js&"
import style0 from "./LkVotes.vue?vue&type=style&index=0&id=74f4449f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4449f",
  null
  
)

export default component.exports